export const loadCloudinaryScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (window.cloudinary) {
      resolve();
      return;
    }

    const existingScript = document.querySelector('script[src*="upload-widget.cloudinary.com"]');
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve());
      existingScript.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://upload-widget.cloudinary.com/global/all.js";
    script.type = "text/javascript";
    script.async = true;

    script.addEventListener("load", () => resolve());
    script.addEventListener("error", reject);

    document.head.appendChild(script);
  });
};

export const loadCloudinaryGalleryScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (typeof window.cloudinary?.galleryWidget === "function") {
      resolve();
      return;
    }

    const existingScript = document.querySelector('script[src*="product-gallery.cloudinary.com"]');
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve());
      existingScript.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://product-gallery.cloudinary.com/latest/all.js";
    script.type = "text/javascript";
    script.async = true;

    script.addEventListener("load", () => resolve());
    script.addEventListener("error", reject);

    document.head.appendChild(script);
  });
};
